import { SummaryMetric } from '../types';
import Icon from '../../../components/AppIcon';

interface SummaryMetricsPanelProps {
  metrics: SummaryMetric[];
}

const SummaryMetricsPanel = ({ metrics }: SummaryMetricsPanelProps) => {
  const getTrendColor = (trend: 'up' | 'down' | 'neutral') => {
    switch (trend) {
      case 'up':
        return 'text-success';
      case 'down':
        return 'text-destructive';
      default:
        return 'text-muted-foreground';
    }
  };

  const getTrendIcon = (trend: 'up' | 'down' | 'neutral') => {
    switch (trend) {
      case 'up':
        return 'TrendingUp';
      case 'down':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics.map((metric, index) => (
        <div key={index} className="bg-card rounded-md border border-border p-6 transition-interactive hover-scale">
          <div className="flex items-start justify-between mb-4">
            <div className="w-12 h-12 rounded-sm bg-primary/10 flex items-center justify-center">
              <Icon name={metric.icon} size={24} color="var(--color-primary)" />
            </div>
            <div className={`flex items-center gap-1 ${getTrendColor(metric.trend)}`}>
              <Icon name={getTrendIcon(metric.trend)} size={16} />
              <span className="text-sm font-medium">
                {metric.change > 0 ? '+' : ''}{metric.change}%
              </span>
            </div>
          </div>
          <h4 className="text-sm text-muted-foreground mb-1">{metric.label}</h4>
          <p className="text-2xl font-semibold text-foreground">{metric.value}</p>
        </div>
      ))}
    </div>
  );
};

export default SummaryMetricsPanel;